import { useEffect } from 'react';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useSetSearchUnitHistoryResponse } from '../context/hooks';
import { isUnitHistoryFormValid } from '../is-unit-history-form-valid';
import { UnitHistoryForm } from '../types';
import { timeRangeValueToDateRange } from '../utils';

export function useRunUnitHistorySearchOnChange(): void {
    const setSearchUnitHistoryResponse = useSetSearchUnitHistoryResponse();
    const { form, mutation } = useIntegratedForm<UnitHistoryForm>();
    const { unitOption, userOption, dateRange, sortTypeOption } = form.watch();
    const mutate = mutation.mutate;
    useEffect(() => {
        const formValues = form.getValues();
        let dateRange = formValues.dateRange;
        // create new date range from time range at search time so it's always up to date with the current time
        if (formValues.timeRangeOption && formValues.timeRangeOption.value !== 'CUSTOM') {
            dateRange = timeRangeValueToDateRange(formValues.timeRangeOption.value);
        }
        if (isUnitHistoryFormValid(formValues)) {
            setSearchUnitHistoryResponse(undefined);
            mutate({ ...formValues, dateRange });
        }
        // don't listen for timeRangeOption because dateRange changes immediately after
    }, [
        form,
        mutate,
        setSearchUnitHistoryResponse,
        unitOption,
        userOption,
        dateRange,
        sortTypeOption,
    ]);
}
